import classNames from "classnames";
import css from "./Spinner.module.scss";

export const Spinner = ({ children, centered, noMargin = false }) => (
  <div
    className={classNames(css.spinner, css["spinner--cover"], {
      [css["spinner--centered"]]: centered,
      [css["spinner--no-margin"]]: noMargin
    })}
  >
    {children}
  </div>
);

export default Spinner;
